export default {
    loadingPageText: "Veuillez patienter pendant le chargement de la page...",
    loadingPageTextAlt: "Chargement de {{resource}}",
    activeSubscriptionLabel: "Abonnement actif",
    activeSubscriptionEndDateLabel: "Expire le {{date}}",
    cancelSubscriptionLabel: "Annuler l'abonnement",
    cancelSubscriptionNotice: "Si vous annulez votre abonnement maintenant, vous conserverez l'accès jusqu'au {{renewalDate}}",
    cancelSubscriptionConfirmationMessage: "Êtes-vous sûr de vouloir annuler votre formule {{subscriptionName}} ? Saisissez votre mot de passe pour confirmer.",
    testCompletedTitle: "Test terminé",
    testCompletedDescription: "Bravo ! Vous avez terminé le test. Vos réponses ont bien été enregistrées.",
    testQuestionsLabel: "Questions",
    answeredQuestionLabel: "Répondues",
    timeUsedLabel: "Temps utilisé",
    returnLabel: "Retour",
    goToDashboard: "Aller au tableau de bord",
    notFoundTitle: "La page que vous recherchez n'existe pas.",
    notFoundDescription: "Elle a peut-être été déplacée ou supprimée.",
    notFoundActionLabel: "Retour à l'accueil",
    serverErrorTitle: "Un problème est survenu de notre côté.",
    serverErrorDescription: "Une erreur inattendue s'est produite. Veuillez recharger la page ou réessayer dans un instant.",
    serverErrorReloadActionLabel: "Recharger la page",
    testProgressLabel: "Progression : {{progress}}/{{total}} répondues",
    testProgressPercentageLabel: "{{percentage}}% terminé",
    readingPassageLabel: "Texte à lire",
    leaveTestLabel: "Quitter le test",
    leaveTestMessage: "Vous êtes sur le point de quitter ce test. Confirmer ?",
    disableTimerActionLabel: "Désactiver",
    enableTimerActionLabel: "Activer",
    toggleTimerLabel: "{{action}} le chronomètre",
    submitTestActionButtonLabel: "Soumettre",
    emptyRecentTestDescription: "Les tests que vous avez déjà complétés apparaîtront ici",
    practiceModeSelectionTitle: "Sélectionnez un mode d'entraînement",
    mockTestSelectionTitle: "Test blanc",
    mockTestSelectionDescription: "Simulez les conditions réelles de l'examen avec des limites de temps strictes. \n Développez votre endurance et votre stratégie pour le jour de l'examen.",
    strictTimeEnforcementTitle: "Chronométrage strict",
    strictTimeEnforcementDescription: "Le chronomètre est obligatoire et soumettra automatiquement le test à expiration. Reproduit les conditions réelles de l'examen.",
    startMockTestActionButtonLabel: "Commencer le test blanc",
    exerciseModeSelectionTitle: "Exercice",
    exerciseModeSelectionDescription: "Entraînez-vous à votre propre rythme, sans contrainte de temps. \n Idéal pour l'apprentissage et le développement des compétences.",
    noTimeEnforcementTitle: "Aucune limite de temps",
    noTimeEnforcementDescription: "Prenez le temps nécessaire pour comprendre chaque question. Le chronomètre est facultatif et ne soumettra pas automatiquement le test.",
    startExerciseModeActionButtonLabel: "Commencer l'exercice",
    noResultsTitle: "Aucun résultat disponible",
    noResultsDescription: "Tous vos résultats aux tests complétés apparaîtront ici. Passez un test pour voir vos résultats",
    noResultsActionLabel: "Lancer un test",

    testInstructionsNotice: "Veuillez lire attentivement les instructions avant de commencer votre test",
    hideTestInstructionsMessage: "Ne plus afficher ce message la prochaine fois",
    startTestActionButtonLabel: "Commencer",
    nextInstructionsPageActionButtonLabel: "Suivant",
    previousInstructionsPageActionButtonLabel: "Précédent",
    instructionPageLabel: "Page {{page}} sur {{pageCount}}",
    generalInstructionPageTitle: "Bienvenue dans votre salle de test LinguaScore",
    generalInstructionPageDescription: "Passons en revue les détails du test et configurons vos préférences",
    totalQuestionCountLabel: "Nombre total de questions",
    timeAllowedLabel: "Temps alloué",
    enableTimerTitle: "Activer le chronomètre",
    enableTimerDescription: "Mettez-vous au défi avec un compte à rebours",
    mockTestDisableTimerNotice: "Impossible de modifier le chronomètre d'un test blanc",
    generalInstructionsProTipMessage: "Astuce : passez en revue toutes les pages d'instructions avant de commencer votre test. Cela vous aidera à comprendre le format et les exigences de l'examen.",
    navigationInstructionsPageTitle: "Navigation et consignes du test",
    navigationInstructionsPageDescription: "Découvrez comment naviguer dans le test et gérer vos réponses",
    navigationInstructionsNavigationSectionTitle: "Navigation",
    navigationInstruction: "Utilisez les boutons Précédent/Suivant pour passer d'une question à l'autre",
    navigationInstructionsAnswersSectionTitle: "Réponses",
    answerInstruction1: "Modifiez vos réponses à tout moment avant de soumettre",
    answerInstruction2: "Suivez votre progression dans le panneau de navigation",
    submissionInstruction: "Rappel : vous devez cliquer sur « Soumettre » une fois terminé",
    submissionNotice: "Le test sera automatiquement soumis à l'expiration du temps si le chronomètre est activé. Une fois soumis, vous ne pourrez plus modifier vos réponses.",
    systemRequirementsTitle: "Configuration requise",
    systemRequirementsDescription: "Assurez-vous que votre système répond à ces exigences pour une expérience optimale.",
    systemRequirementsBrowserTitle: "Navigateur",
    systemRequirementRecommendedBrowserLabel: "recommandé",
    systemRequirementDisplayTitle: "Affichage",
    systemRequirementDisplayResolution: "Résolution minimale de 1024x768",
    systemRequirementDisplayFullScreenRecommendation: "Mode plein écran recommandé",
    systemRequirementDisplayZoomLevel: "Niveau de zoom à 100%",
    systemRequirementLighting: "Bon éclairage",
    callToStartTestActionLabel: "Prêt à commencer ?",
    callToStartTestActionNotice: "En cliquant sur « Commencer » ci-dessous, vous reconnaissez avoir :",
    callToStartTestActionNotice1: "Lu et compris toutes les instructions",
    callToStartTestActionNotice2: "Vérifié que votre système répond aux exigences",
    callToStartTestActionNotice3: "Être prêt à passer le test sans interruption",

    testSubmissionLoadingMessage: "Envoi de votre test en cours, cela peut prendre un moment...",
    confirmDialogActionButtonLabel: "Confirmer",
    cancelDialogActionButtonLabel: "Annuler",
    accountUpdateSuccessMessage: "Modifications enregistrées avec succès",
    unknownErrorMessage: "Une erreur inconnue s'est produite. Veuillez ressayer.",
    loadingErrorMessage: "Impossible de charger {{label}}. Vous pouvez réessayer.",
    submitErrorMessage: "Impossible d'envoyer {{label}}. Vous pouvez réessayer.",
    retryActionLabel: "Réessayer",

    enableNotificationDialogTitle: "Suivez votre progression en temps réelle",
    enableNotificationDialogDescription: "Recevez une notification instantanée dès que votre test est corrigé pour consulter vos retours et continuer à progresser sans interruption.",
    enableNotificationActionButtonLabel: "Recevoir les notifications",

    hidePreTestInstructionsLabel: "Ne plus afficher",
    speakingTestUploadLabel: "Enregistrement de vos réponses...",
    speakingTestUploadFailedMessage: "Impossible d'enregistrer vos réponses. Veuillez réssayer.",
    allowMicrophoneAccessWarningMessage: "Veuillez autoriser l'utilisation du micro pour continuer.",
    allowMicPrompt: "Vous devez autoriser l'accès au micro",
    allowMicActionButtonLabel: "Autoriser l'accès",
    speakingPartTwoCountdownLabel: "Répondez dans {{seconds}}",

    paymentCancelledTitle: "Paiement annulé",
    paymentCancelledDescription: "Votre paiement a été annulé. Veuillez réessayer.",

    paymentFailedTitle: "Échec du paiement",
    paymentFailedDescription: "Le paiement n'a pas pu être effectué. Cela peut être dû à un problème de connexion ou à un solde insuffisant. Vérifiez votre compte, puis réessayez.",

    paymentSuccessTitle: "Paiement effectué",
    paymentSuccessDescription: "Votre paiement a été effectué avec succès. Vous pouvez maintenant fermer cette fenêtre.",

    paymentPendingTitle: "Paiement en attente",
    paymentPendingDescription: "Votre paiement a été initié et est en attente de validation. Nous le confirmons auprès d'Ikeepay, cela prend généralement quelques secondes.",

    closePaymentStatusDialogActionLabel: "Fermer",

    notificationsTitle: "Notifications",
    notificationsDescription: "Retrouvez ici toutes les notifications concernant votre compte et vos résultats de tests.",
    emptyNotificationsText: "Vos notifications apparaîtront ici.",
    notificationItemActionLabel: "Marquer comme lu",
    plainLoadingText: "Veuillez patienter...",
    defaultLoadingErrorMessage: "Une erreur est survenue. Veuillez réssayer.",
    resultFeedbackPositiveActionLabel:"Voir les résultats",
    resultFeedbackNegativeActionLabel:"Masquer",
    paymentProcessingNotice:"La validation de votre paiement peut prendre jusqu'à 5 mins, une fois confirmée.",

    /**
     * Codes d'erreur du serveur.
     *
     * Les clés reprennent l'énumération `ErrorCode` de
     * backend/src/utils/ErrorCodes.ts et correspondent exactement aux valeurs
     * `messageCode` renvoyées par l'API : un message s'affiche donc via
     * `t(response.messageCode, {field: response.field})`, sans table de correspondance.
     */
    OPERATION_SUCCESSFUL: "Opération exécutée avec succès.",
    REQUEST_INVALID: "Votre demande est invalide ou mal formulée. Veuillez réessayer.",
    RESOURCE_NOT_FOUND: "Nous ne parvenons pas à trouver cette ressource.",
    AUTHENTICATION_REQUIRED: "Vous devez être connecté pour continuer.",
    ACCESS_FORBIDDEN: "Vous n'êtes pas autorisé à accéder à cette ressource.",
    INTERNAL_ERROR: "Une erreur inconnue s'est produite. Veuillez réessayer.",

    FIELD_REQUIRED: "Le champ '{{field}}' est requis.",
    FIELD_INVALID_TYPE: "Le champ '{{field}}' a un format inattendu.",
    FIELD_NOT_UNIQUE: "Ce '{{field}}' est déjà utilisé.",
    FIELD_NOT_UNIQUE_email: "Cette adresse e-mail est déjà utilisée.",
    FIELD_MAX_VALUE_EXCEEDED: "Le champ '{{field}}' dépasse la valeur maximale autorisée.",
    FIELD_MIN_VALUE_REQUIRED: "Le champ '{{field}}' est en dessous de la valeur minimale autorisée.",
    FIELD_TOO_LONG: "Le champ '{{field}}' est trop long.",
    FIELD_TOO_SHORT: "Le champ '{{field}}' est trop court.",
    FIELD_VALUE_NOT_ALLOWED: "Cette valeur n'est pas autorisée pour '{{field}}'.",
    FIELD_REFERENCE_NOT_FOUND: "Le '{{field}}' sélectionné n'existe plus.",
    FIELD_EMPTY: "Le champ '{{field}}' ne peut pas être vide.",
    FIELD_ARRAY_ITEM_INVALID: "Un des éléments de '{{field}}' est invalide.",
    FIELD_NESTED_INVALID: "Certaines informations de '{{field}}' sont invalides.",
    FIELD_PREFIX_REQUIRED: "Le champ '{{field}}' ne commence pas par la valeur attendue.",
    FIELD_SUFFIX_REQUIRED: "Le champ '{{field}}' ne se termine pas par la valeur attendue.",
    FIELD_VALUES_NOT_MATCHING: "Le champ '{{field}}' ne correspond pas.",
    FIELD_PASSWORD_NOT_MATCHING: "Les mots de passe ne correspondent pas.",

    USER_INVALID_CREDENTIALS: "Email ou mot de passe incorrect. Veuillez réessayer.",
    USER_PASSWORD_INCORRECT: "Mot de passe incorrect, veuillez réessayer.",
    USER_OLD_PASSWORD_INCORRECT: "Votre mot de passe actuel est incorrect, veuillez réessayer.",
    USER_IDENTICAL_PASSWORD: "Le nouveau mot de passe ne peut pas être identique à l'ancien.",
    USER_ACCOUNT_DISABLED: "Votre compte a été désactivé. Veuillez contacter l'assistance pour le réactiver.",
    USER_EMAIL_UNAVAILABLE: "Cet email n'est pas disponible.",
    USER_EMAIL_NOT_FOUND: "Cet email ne correspond à aucun compte enregistré.",
    USER_EMAIL_NOT_VERIFIED: "Vous devez vérifier votre adresse email pour continuer.",
    USER_PROVIDER_ACCOUNT_NOT_FOUND: "Aucun compte n'est associé à ce fournisseur de connexion.",
    USER_ACCOUNT_NOT_RESOLVED: "Nous n'avons pas pu ouvrir votre compte. Veuillez vous reconnecter.",
    USER_INVALID_TOKEN: "Votre session est invalide. Veuillez vous reconnecter.",
    USER_TOKEN_EXPIRED: "Votre session a expiré. Veuillez vous reconnecter.",
    SESSION_EXPIRED: "Votre session a expiré, veuillez réessayer.",

    EXAM_NOT_AVAILABLE: "Cet examen n'est pas encore disponible. Veuillez en choisir un autre.",
    EXAM_UNKNOWN: "Nous ne reconnaissons pas cet examen. Veuillez en choisir un autre.",
    REGION_NOT_SUPPORTED: "Cette région n'est pas encore prise en charge.",
    SUBSCRIPTION_REQUIRED: "Un abonnement actif est requis pour continuer.",
    ACCOUNT_INSUFFICIENT_BALANCE: "Solde insuffisant, veuillez recharger et réessayer.",
    ELEVATED_ROLE_REQUIRED: "Vous n'avez pas les permissions requises pour cette action."
    ,
    USER_EMAIL_ALREADY_VERIFIED: "Cette adresse email est déjà vérifiée.",
    USER_EMAIL_VERIFICATION_REQUIRED: "Veuillez vérifier votre adresse email pour continuer.",
    LINK_INVALID: "Ce lien est invalide ou a déjà été utilisé.",
    LINK_EXPIRED: "Ce lien a expiré. Veuillez en demander un nouveau.",
    PASSWORD_RESET_EMAIL_SENT: "Si cet email correspond à un compte, nous avons envoyé un lien de réinitialisation. Veuillez consulter votre boîte de réception.",
    PASSWORD_RESET_SUCCESSFUL: "Votre mot de passe a été réinitialisé. Vous pouvez maintenant vous connecter.",
    EMAIL_VERIFICATION_SENT: "Email de vérification envoyé. Veuillez consulter votre boîte de réception.",
    EMAIL_VERIFICATION_SUCCESSFUL: "Votre adresse email a été vérifiée.",
    ACCOUNT_DELETED: "Votre compte a été supprimé.",
    USER_DELETION_NOT_CONFIRMED: "Cela ne correspond pas. Veuillez vérifier et réessayer.",
    USER_ADMIN_DELETION_FORBIDDEN: "Les comptes administrateur ne peuvent pas être supprimés ici.",
    USER_SELF_DELETION_FORBIDDEN: "Vous ne pouvez pas supprimer votre propre compte ici.",
    FREE_TRIAL_UNAVAILABLE: "Vous avez déjà utilisé votre essai gratuit. Choisissez une offre pour continuer.",
    SUBSCRIPTION_NOT_AVAILABLE_IN_REGION: "Cette offre n'est pas disponible dans votre région. Veuillez en choisir une autre.",
    TRANSACTION_ALREADY_COMPLETED: "Ce paiement a déjà été traité.",
    PARTNER_ROLE_REQUIRED: "Cet espace est réservé aux partenaires LinguaScore."
}
